import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/auth/social'

/**
 * Sign in and sign up with GitHub or Google.
 *
 * The flow itself is a top-level browser navigation (the provider's consent
 * screen has to be a page, not an XHR), so the only API calls are asking which
 * providers are on, and building the URL that starts the flow.
 */
class AuthSocialService {
    /**
     * The providers the login and sign-up screens may offer. Empty while the
     * API's `enable-social-login` flag is off or no provider is configured.
     *
     * @returns {Promise<string[]>}
     */
    async providers() {
        const response = await apiClient.get(API_INTERNAL_BASE)
        const providers = response.data?.data?.providers

        return Array.isArray(providers) ? providers : []
    }

    /**
     * Where to send the browser to start signing in with a provider. The API
     * answers with a redirect to the provider, and the provider later sends
     * the browser back to the SPA's login screen with the outcome.
     *
     * @param {string} provider - `github` or `google`
     * @returns {string}
     */
    redirectUrl(provider) {
        return (
            import.meta.env.VITE_API_INTERNAL +
            API_INTERNAL_BASE +
            '/' +
            encodeURIComponent(provider) +
            '/redirect'
        )
    }
}

export default new AuthSocialService()
